module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img41.adcb23fc.jpg";